import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { APP_LINKS } from "@/constants/appLinks";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/#features" },
      { label: "Creators", to: "/#creators" },
      { label: "Safety", to: "/#safety" },
      { label: "About", to: "/#about" },
      { label: "Support", to: "/support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Community Guidelines", to: "/legal/community-guidelines" },
      { label: "Founder Creator Terms", to: "/legal/founder-terms" },
      { label: "Cookie Policy", to: "/legal/cookies" },
    ],
  },
  {
    title: "More",
    links: [
      { label: "Monetization Terms", to: "/legal/monetization-terms" },
      { label: "Copyright / IP", to: "/legal/ip-policy" },
      { label: "Grievance Policy", to: "/legal/grievance" },
      { label: "Child Safety", to: "/legal/child-safety" },
      { label: "Account Deletion", to: "/legal/account-deletion" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 px-6 pt-16 pb-10" data-testid="site-footer">
      <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-[40rem] -translate-x-1/2 rounded-full bg-indril-saffron/10 blur-[130px]" />
      <div className="relative mx-auto grid max-w-6xl grid-cols-2 gap-10 md:grid-cols-5">
        <div className="col-span-2">
          <Logo markClass="h-9 w-9" />
          <p className="mt-4 max-w-xs text-sm text-white/50">
            A fast, secure and creator-first social platform built for India — videos, photos, stories and conversations in one place.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a href={APP_LINKS.appStore} target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs text-white/70 hover:text-white">App Store</a>
            <a href={APP_LINKS.googlePlay} target="_blank" rel="noopener noreferrer" className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs text-white/70 hover:text-white">Google Play</a>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="mb-4 text-sm font-semibold text-white">{c.title}</h4>
            <ul className="space-y-2.5">
              {c.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-white/50 transition-colors hover:text-white">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="relative mx-auto mt-12 flex max-w-6xl flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-sm text-white/40 sm:flex-row">
        <span>© 2026 IND RIL. All rights reserved.</span>
        <Link to="/support" className="hover:text-white">Contact &amp; Grievance</Link>
      </div>
    </footer>
  );
};
